export default {
      id: "icon--ticket-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--ticket-usage",
      toString: function () {
        return this.url;
      }
    }